<template>
    <div class="h-100 d-flex flex-column">
        <!-- Поле ввода адреса -->

        <div v-if="this.satge === 0">
            <p v-if="this.loading || this.providers.length" class="fsp14 neue mbp-8" for="address">{{ $t('components.service.AMLCheck.12') }}</p>
            <BlockLoader v-if="this.loading" :loading="true" />
            <!-- Пустой каталог — штатное состояние: msForm скрывает из публичного
                 списка aml_provider-формы без привязанного шлюза. Отличаем «пусто»
                 от «ещё грузится» явным текстом, а не пустой плиткой. -->
            <p v-else-if="!this.providers.length" class="fsp14 neue primary-grey">{{ $t('components.service.AMLCheck.17') }}</p>
            <div v-else class="provider-grid">
                <div
                    v-for="(provider, index) in providers"
                    :key="index"
                    class="provider-item d-flex flex-column align-items-center justify-content-center pp-16"
                    @:click="this.getBlockchains(provider)"
                >
                    <img 
                        :src="provider.logo"
                        :alt="provider.name"
                        class="provider-logo mbp-16"
                    />
                    <span class="fsp20 neue text-center">{{ provider.name }}</span>
                </div>
            </div>
        </div>
        
        <div class="" v-if="this.satge === 1 || this.satge === 2">
            <label class="fsp14 neue mbp-8" for="address">{{ $t('components.service.AMLCheck.1') }}</label>
            <InputSimple
                class="fsp14 neue"
                :iconColor="'#a9a9a9'"
                :icon="this.system_alias_name ? `crypto-${this.system_alias_name}` : 'wallet'"
                type="text" 
                id="address"
                :dataValue="this.data.address"
                :placeholder="$t('components.service.AMLCheck.2')"
                @updateParentState="updateAddress"
            />
        </div>
        
        <!-- Плитка блокчейнов -->
        <div v-if="this.satge === 1" class="flex-grow-1 d-flex flex-column justify-content-between">

        <BlockLoader v-if="this.loading" :loading="true" />
        <div v-else>
            <!-- Плитка AML-провайдеров (поле aml_provider__provider), если форма его прислала -->
            <div v-if="this.providerOptions.length" ref="providerBlock" class="mbp-16">
                <p class="fsp14 neue mbp-8 mtp-32">{{ $t('components.service.AMLCheck.13') }}</p>
                <div class="aml-provider-grid">
                    <div
                        v-for="opt in providerOptions"
                        :key="opt.value"
                        class="aml-blockchain-item d-flex align-items-center justify-content-center neue fsp14"
                        :class="{ 'selected': this.data.provider === opt.value }"
                        @click="selectProvider(opt)"
                    >
                        <span>{{ opt.label }}</span>
                    </div>
                </div>
            </div>
            <p class="fsp14 neue mbp-8 mtp-32" ref="gridTitle">{{ $t('components.service.AMLCheck.3') }}</p>
            <!-- Перечень сетей пуст — форма провайдера недонастроена. Говорим об
                 этом прямо: пустой грид с заблокированной кнопкой неотличим от
                 незавершённой загрузки. -->
            <p v-if="!this.blockchains.length" class="fsp14 neue primary-grey">{{ $t('components.service.AMLCheck.18') }}</p>
            <template v-else>
                <InputSimple
                    id="search-blockchain"
                    class="fsp14 neue mb16"
                    icon="search-grey"
                    :dataValue="this.searchBlockchain"
                    :placeholder="`${$t('components.service.TableList.1')}...`"
                    @updateParentState="(e) => searchBlockchain = e.value"
                />
                <div class="aml-blockchain-grid" ref="blockchainGrid" :style="{ height: gridHeight + 'px' }">
                    <div
                        v-for="(name, index) in sortedBlockchains"
                        :key="name.code || `unconfigured-${index}`"
                        class="aml-blockchain-item d-flex align-items-center neue fsp14"
                        :class="{
                            'selected': name.code && this.data.system_alias === name.code,
                            'unconfigured': !name.code
                        }"
                        @click="selectBlockchain(name)"
                    >
                        <!-- Опция без value: сеть в форме заведена, но не настроена.
                             Не прячем её — показываем плиткой с пояснением, недоступной
                             для выбора (иначе кнопка проверки молча осталась бы серой). -->
                        <div v-if="!name.code" class="blockchain-placeholder me-2"></div>
                        <Icon
                            v-else
                            :name="`crypto-${name.value}`"
                            class="blockchain-icon me-2"
                            :size="'c32'"
                        />
                        <span>{{ name.code ? name.value : $t('components.service.AMLCheck.19') }}</span>
                    </div>
                </div>
            </template>
        </div>
        
        <!-- Кнопка проверки -->
        <div v-if="!this.loading" class="pt-3 d-flex gap-2 position-fixed bottom-0 left-0 end-0 py16 px24 w-100 bg-white" ref="checkButton">
            <Button 
                @click="back" 
                :name="$t('components.service.AMLCheck.11')" 
                type="btn-outline-grey" 
                class="equal-width" 
            />
            <Button 
                class="equal-width h56"
                type="btn-warning"
                :disabled="!this.data.address || !this.data.system_alias || (this.providerOptions.length && !this.data.provider)"
                @click="performCheck"
            >
                <Icon name="search-grey" :color="'#ffffff'" class="mrp-8" />
                <span class="neue fsp14">{{ $t('components.service.AMLCheck.4') }}</span>
            </Button>
        </div>

        </div>

        <div v-else-if="this.satge === 2 && this.result">
            <div 
                class="aml-result-message d-flex align-items-center mtp-16"
                :class="{ 'error': this.result.result != '0' }"
            >
                <Icon 
                    :name="this.result.result == '0' ? 'check-green' : 'info'" 
                    :color="this.result.result != '0' ? '#FF3B30' : false"
                    class="me-2" 
                />
                <span class="neue fsp14">
                    {{ this.result.result == '0' ? $t('components.service.AMLCheck.8') : this.result.result_text }}
                    <!-- Вывод о судьбе проверки при отказе биллинг-гейта:
                         причину назвал сервис, здесь — что с самой проверкой. -->
                    <span v-if="this.result.hint" class="d-block mtp-8">{{ this.result.hint }}</span>
                </span>
            </div>
            <!-- Блок с прогрессбаром -->
            <div v-if="this.result && this.result.result == '0'">
            <div class="d-flex justify-content-center progress-container">
                <div class="progress-circle-container">
                    <svg width="257" height="153" viewBox="0 0 257 153" class="progress-circle">
                        <!-- Фоновая дуга -->
                        <path
                            d="M 25 128.5 A 103.5 103.5 0 1 1 232 128.5"
                            fill="none"
                            stroke="#E5E7EB"
                            stroke-width="16"
                            stroke-linecap="round"
                        />
                        <!-- Прогрессная дуга -->
                        <path
                            d="M 25 128.5 A 103.5 103.5 0 1 1 232 128.5"
                            fill="none"
                            stroke-width="16"
                            stroke-linecap="round"
                            :stroke-dasharray="progressDashArray"
                            :stroke-dashoffset="progressDashOffset"
                            :stroke="progressColor"
                            class="progress-arc"
                        />
                    </svg>
                    <!-- Текст с процентами -->
                    <div class="progress-text">
                        <span class="progress-percentage neue-bold" :style="{ color: progressColor }">{{ Math.round(this.animatedProgress) }}%</span>
                    </div>
                    <!-- Подписи 0 и 100 -->
                    <div class="progress-labels">
                        <span class="label-start">0</span>
                        <span class="label-end">100</span>
                    </div>
                </div>
            </div>
            
            <!-- Текст риска под прогрессбаром -->
            <div class="risk-text neue fsp20" :style="{ color: progressColor }">
                {{ riskText }}
            </div>
            </div>
            
            <!-- Кнопка проверки другого адреса -->
            <div class="btn-container">
                <Button 
                    class="equal-width check-another-btn h56"
                    type="btn-warning"
                    @click="resetCheck"
                >
                    <Icon name="refresh" :color="'#ffffff'" class="mrp-8" />
                    <span class="neue fsp14">{{ $t('components.service.AMLCheck.9') }}</span>
                </Button>
                <Button 
                    v-if="this.pdf"
                    class="equal-width h56"
                    type="btn-outline-grey"
                    @click="downloadPDF"
                    @mouseover="iconHover = 'download-file'"
                    @mouseleave="iconHover = false"
                >
                    <Icon name="download-file" class="mrp-8" :active="iconHover !== 'download-file'" />
                    <span class="neue fsp14">{{ $t('components.service.AMLCheck.10') }}</span>
                </Button>
            </div>
            
        </div>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Button from '@/components/service/Button';
import Icon from '@/components/icons/Icon';
import BlockLoader from '@/components/service/BlockLoader';

// Терминальные исходы биллинг-гейта msAML: 402 — списание цены формы не
// прошло; 404/422 — форма или сеть непригодна; 409 — квота исчерпана, форма
// вне глубины тарифа либо модуль подписок не сконфигурирован. Проверки в этих
// случаях не было. 503 (исход не подтверждён) сюда не входит — у него своя
// приписка с предложением повторить.
const GATE_STATUSES = [402, 404, 409, 422];

export default {
    name: 'AMLCheck',
    components: {
        InputSimple,
        Button,
        Icon,
        BlockLoader
    },
    data() {
        return {
            providers: [],
            blockchains: [],
            providerOptions: [],
            selected_provider: false,
            system_alias_name: '',
            searchBlockchain: '',
            data: {
                type: 'address',
                system_alias: '',
                address: '',
                provider: '',
            },
            aml_type: this.$store.state.config.AML_TYPE,
            satge: 0,
            loading: false,
            result: false,
            animatedProgress: 0,
            gridHeight: 300,
            iconHover: false,
            pdf: false
        }
    },
    computed: {
        sortedBlockchains() {
            const filtered = this.blockchains.filter(b => b.value.toLowerCase().includes(this.searchBlockchain.toLowerCase()));
            if (!this.selected_provider || this.searchBlockchain) return filtered;
            const stats = this.getUsageStats(this.selected_provider.code || '');
            if (!Object.keys(stats).length) return filtered;
            return [...filtered].sort((a, b) => (stats[b.code] || 0) - (stats[a.code] || 0));
        },
        progressDashArray() {
            // Длина полукруга (π * радиус)
            const circumference = Math.PI * 103.5;
            return `${circumference} ${circumference}`;
        },
        progressDashOffset() {
            const circumference = Math.PI * 103.5;
            return circumference - (this.animatedProgress / 100) * circumference;
        },
        progressColor() {
            const progress = Math.round(this.animatedProgress);
            if (progress <= 30) {
                return '#22c55e'; // Зеленый
            } else if (progress <= 69) {
                return '#eab308'; // Желтый
            } else {
                return '#ef4444'; // Красный
            }
        },
        riskText() {
            const progress = Math.round(this.animatedProgress);
            if (progress <= 30) {
                return this.$t('components.service.AMLCheck.5');
            } else if (progress <= 69) {
                return this.$t('components.service.AMLCheck.6');
            } else {
                return this.$t('components.service.AMLCheck.7');
            }
        }
    },
    watch: {
        'result.tables': {
            handler() {
                const firstTable = this.result?.tables ? Object.values(this.result.tables)[0] : null;
                if (firstTable?.colvalues?.[0]) {
                    this.$nextTick(() => {
                        this.animateProgress();
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        back() {
            this.satge = 0;
            this.selected_provider = false;
            this.blockchains = [];
            this.providerOptions = [];
            this.data = {
                type: 'address',
                system_alias: '',
                address: '',
                provider: '',
            },
            this.system_alias_name = '';
            this.$store.commit('SIDE_PANEL_SET_TITLE', '');
        },
        base64ToBlob() {
            const byteCharacters = atob(this.pdf);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: "application/pdf" });
        },
        getBlockchains(arg) {
            this.loading = true;
            this.axios.post('GetPublicFormFields', {no_loader: true, data: {code: arg.code}}).then(res => {
                // Не молчаливый выход, а страховка от разбора чужого тела: об
                // ошибке пользователю уже сказано. result != 0 доходит сюда лишь
                // ms-HTTP-200 (Response::jsonError без статуса) — там взведён
                // error:true, и lib.res() показал тост; на честном не-2xx PHP
                // отдаёт статус, промис реджектится и .then() вовсе не зовётся
                // (тост от lib.err). Своё сообщение здесь было бы вторым подряд.
                if (res.data.body.result && res.data.body.result != '0') {
                    return;
                }
                // Опции блокчейнов лежат в поле aml_provider__networks (SELECT),
                // а не обязательно в fields[0] — у форм AML провайдеров первым
                // идёт STRING-поле aml_provider__address, у которого field_options нет.
                const fields = res.data.body.tables.fields.colvalues;
                const networksField = fields.find(f => f.alias === 'aml_provider__networks');
                if (networksField && networksField.field_options) {
                    // code — значение опции КАК ЕСТЬ: оно уходит в info.system_alias,
                    // а msAML сверяет сеть с опциями формы точным совпадением.
                    // Прежняя склейка `value,text` для опций без запятой давала бы
                    // 422 «сеть не принадлежит форме». value — часть до запятой:
                    // подпись плитки и имя иконки crypto-<валюта>.
                    //
                    // Опции с пустым value НЕ отсеиваем: тихий отсев спрятал бы
                    // недонастроенную форму — плитка просто исчезла бы из витрины,
                    // и о дырке в настройке никто бы не узнал. Такая опция остаётся
                    // в списке видимой и недоступной для выбора (см. шаблон и
                    // selectBlockchain), с подписью «сеть не настроена».
                    this.blockchains = networksField.field_options.map(opt => {
                        const raw = typeof opt.value === 'string' ? opt.value : '';
                        return {
                            code: raw,
                            value: raw.split(',')[0]
                        };
                    });
                }
                // Опциональное поле aml_provider__provider (SELECT, как networks):
                // value = код AML-провайдера, text = его имя. Рендерится плиткой и
                // уходит в шлюз внутри info.provider — только если форма его прислала.
                const providerField = fields.find(f => f.alias === 'aml_provider__provider');
                if (providerField && providerField.field_options && providerField.field_options.length) {
                    this.providerOptions = providerField.field_options.map(opt => ({
                        value: opt.value,
                        label: opt.text || opt.value
                    }));
                } else {
                    this.providerOptions = [];
                }
                this.selected_provider = arg;
                this.satge = 1;
                this.calculateGridHeight();
                this.$store.commit('SIDE_PANEL_SET_TITLE', `${this.$t('components.service.SidePanel.1')} (${arg.name})`);
            }).finally(() => {
                this.loading = false;
            });
        },
        downloadPDF() {
            const blob = this.base64ToBlob(this.pdf);
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${this.data.system_alias.split(',')[0].toUpperCase()}_${this.data.address}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        updateAddress(data) {
            this.data.address = data.value;
        },
        selectBlockchain(arg) {
            // Сеть без value выбрать нельзя: пустой system_alias msAML отклонит
            // как 422. Плитка остаётся на виду (о недонастроенной форме должно
            // быть видно), но клик по ней ничего не выбирает.
            if (!arg.code) {
                return;
            }
            this.data.system_alias = arg.code;
            this.system_alias_name = arg.value;
        },
        selectProvider(opt) {
            this.data.provider = opt.value;
        },
        performCheck() {
            if (!this.data.address || !this.data.system_alias) {
                return;
            }

            // Вход msAML — код выбранной aml_provider-формы: шлюз и перечень
            // допустимых сетей сервис резолвит по её привязке сам (86caztn32).
            let params = {
                type: this.data.type,
                info: this.setInfo(this.data.address),
                form: this.selected_provider.code
            };

            this.$store.dispatch('openModal', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    this.trackUsage(this.selected_provider.code, this.data.system_alias);
                    this.loading = true;
                    // no_error_msg: отказ биллинг-гейта показываем сами — в блоке
                    // результата, с приписом о судьбе проверки; авто-тост lib.err
                    // дал бы то же сообщение вторым экземпляром и без него.
                    this.axios.post('GetAmlRisk', {no_loader: true, no_error_msg: true, data: params}).then(res => {
                        this.result = res.data.body;
                        this.satge = 2;
                        const firstTable = this.result?.tables ? Object.values(this.result.tables)[0] : null;
                        if (firstTable?.colvalues?.[0]) {
                            let fullData = firstTable.colvalues[0].full_data;
                            if (typeof fullData === 'string') {
                                fullData = JSON.parse(fullData);
                            }
                            this.pdf = fullData?.pdf_report_base64;
                        }
                    }).catch(err => {
                        this.showCheckError(err);
                    }).finally(() => {
                        this.loading = false;
                    });
                }}
            });
        },
        /**
         * Показать отказ проверки: текст сервиса + вывод о её судьбе.
         *
         * Исходы биллинг-гейта msAML (квота формы глубины тарифа либо цена
         * формы) приходят честными не-2xx — интерцептор отклоняет промис, и
         * без этой ветки экран молча остался бы на форме. Причину формулирует
         * сервис (result_text локализован им по заголовку lang), экран лишь
         * оформляет ответ: 402 списание не прошло, 409 квота исчерпана либо
         * форма недоступна на тарифе, 404/422 форма или сеть непригодна — всё
         * это терминально, проверки не было; 503 — исход не подтверждён, и
         * обещать «ничего не списано» нельзя, поэтому предлагаем повторить.
         * У прочих сбоев (сеть, недоступный фасад) приписки нет: сказать о
         * судьбе проверки нечего, а домысливать — тот же фолбек.
         */
        showCheckError(err) {
            const status = err?.response?.status;
            const body = err?.response?.data?.body;
            const text = this.$lib.unwrapResultText(
                (body && body.result_text) || this.$t('components.service.AMLCheck.14')
            );
            let hint = '';
            if (status === 503) {
                hint = this.$t('components.service.AMLCheck.16');
            } else if (GATE_STATUSES.includes(status)) {
                hint = this.$t('components.service.AMLCheck.15');
            }
            this.result = { result: '1', result_text: text, hint };
            // Отчёта у отказа нет — гасим кнопку скачивания, иначе она отдала
            // бы PDF предыдущей проверки под чужим адресом.
            this.pdf = false;
            this.satge = 2;
        },
        setInfo(address) {
            // Новый контракт msAML: system_alias и provider уходят внутри info
            // (passthrough info → fields на стороне msAML), не отдельными полями.
            let res = {
                system_alias: this.data.system_alias,
                addresses: [address]
            };
            // provider (aml_provider__provider) уходит в шлюз внутри info, если выбран
            if (this.data.provider) {
                res.provider = this.data.provider;
            }
            return JSON.stringify(res);
        },
        animateProgress() {
            const firstTable = this.result?.tables ? Object.values(this.result.tables)[0] : null;
            if (!firstTable?.colvalues?.[0]) {
                return;
            }

            const targetProgress = parseFloat(firstTable.colvalues[0].risk);
            const duration = 1000; // 1 секунда
            const startTime = Date.now();
            const startProgress = 0;
            
            const animate = () => {
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // Линейная анимация для ровного заполнения
                this.animatedProgress = startProgress + (targetProgress - startProgress) * progress;
                
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.animatedProgress = targetProgress;
                }
            };
            
            requestAnimationFrame(animate);
        },
        getUsageStats(providerCode) {
            try {
                const data = JSON.parse(localStorage.getItem('aml_favorites') || '{}');
                return data[providerCode] || {};
            } catch {
                return {};
            }
        },
        trackUsage(providerCode, blockchainCode) {
            try {
                const data = JSON.parse(localStorage.getItem('aml_favorites') || '{}');
                if (!data[providerCode]) data[providerCode] = {};
                data[providerCode][blockchainCode] = (data[providerCode][blockchainCode] || 0) + 1;
                localStorage.setItem('aml_favorites', JSON.stringify(data));
            } catch {
                // localStorage unavailable
            }
        },
        resetCheck() {
            this.satge = 0;
            this.data.address = '';
            this.data.system_alias = '';
            this.data.provider = '';
            this.animatedProgress = 0;
            this.selected_provider = false;
            this.pdf = false;
            this.$store.commit('SIDE_PANEL_SET_TITLE', '');
        },
        calculateGridHeight() {
            this.$nextTick(() => {
                if (this.$refs.gridTitle && this.$refs.checkButton) {
                    const containerHeight = window.innerHeight;
                    const titleHeight = this.$refs.gridTitle.offsetHeight;
                    const buttonHeight = this.$refs.checkButton.offsetHeight;
                    const providerHeight = this.$refs.providerBlock ? this.$refs.providerBlock.offsetHeight : 0;
                    const inputHeight = 155; // Примерная высота поля ввода с отступами
                    const padding = 150; // Отступы панели и дополнительные отступы

                    this.gridHeight = containerHeight - titleHeight - buttonHeight - providerHeight - inputHeight - padding;
                    
                    // Минимальная высота
                    if (this.gridHeight < 200) {
                        this.gridHeight = 200;
                    }
                }
            });
        }
    },
    created() {
        this.loading = true;
        this.axios.post('GetPublicFormsList', {no_loader: true, data: {'form_type': 'aml_provider'}}).then(res => {
            if (res.data.body.result !== 0) {
                return;
            }
            this.providers = res.data.body.tables.forms.colvalues;
        }).finally(() => {
            this.loading = false;
        });
    },
    mounted() {
        this.calculateGridHeight();
        window.addEventListener('resize', this.calculateGridHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateGridHeight);
    }
}
</script>

<style lang="scss" scoped>
.aml-blockchain-grid {
    display: grid;
    gap: 16px 16px;
    overflow-y: auto;
    padding-right: 8px;
    align-content: start;
    
    /* Для экранов больше 768px: 3 колонки на всю ширину */
    @media (min-width: 769px) {
        grid-template-columns: repeat(3, 1fr);
    }
    
    /* Для экранов 768px и меньше: 2 колонки на всю ширину */
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
    
    /* Кастомный скроллбар */
    &::-webkit-scrollbar {
        width: 6px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
        margin-left: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: $menu-bg;
        border-radius: 3px;
        
        &:hover {
            background: $menu-bg2;
        }
    }
    
    &::-webkit-scrollbar-button {
        display: none;
    }
}

.aml-blockchain-item {
    height: 56px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 12px;
    border: 1px solid $primary-stroke;
    border-radius: 12px;
    background-color: white;
    
    &:hover:not(.selected) {
        border-color: var(--bs-primary) !important;
        background-color: #f8fafc !important;
    }
    
    &.selected {
        border-color: $menu-bg;
        background-color: $bg-light-blue;
        color: inherit;
    }

    /* Сеть без value: видна, но выбрать нельзя — плитка остаётся в витрине,
       чтобы недонастроенная форма не пряталась от пользователя. */
    &.unconfigured {
        cursor: not-allowed;
        color: $primary-grey;

        &:hover {
            border-color: $primary-stroke !important;
            background-color: white !important;
        }
    }

    span {
        line-height: 1;
        display: flex;
        align-items: center;
    }
}

.provider-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.aml-provider-grid {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(2, 1fr);

    @media (min-width: 769px) {
        grid-template-columns: repeat(3, 1fr);
    }
}

.provider-item {
    cursor: pointer;
    border: 1px solid $primary-stroke;
    border-radius: 12px;
    background-color: white;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: var(--bs-primary) !important;
        background-color: #f8fafc !important;
    }
}

.provider-logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
}

.blockchain-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blockchain-placeholder {
    width: 32px;
    height: 32px;
    background-color: #e5e7eb;
    border-radius: 50%;
    flex-shrink: 0;
}

.aml-result-message {
    width: 100%;
    padding: 16px;
    border: 1px solid $color-notification;
    border-radius: 8px;
    background-color: #F3FFF6;
    color: $color-notification;
    
    &.error {
        border-color: $color-invalid;
        background-color: #FFF5F5;
        color: $color-invalid;
    }
    
    .me-2 {
        margin-right: 10px;
    }
}

.progress-circle-container {
    position: relative;
    width: 257px;
    height: 153px;
    margin-bottom: 16px;
}

/* .progress-circle - поворот убран, дуга правильно ориентирована */

.progress-arc {
    transition: stroke-dashoffset 0.5s ease-in-out, stroke 0.3s ease-in-out;
}

.progress-text {
    position: absolute;
    top: calc(84% - 15px);
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.progress-percentage {
    font-size: 56px;
    font-weight: 600;
    transition: color 0.3s ease-in-out;
}

.progress-labels {
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
}

.label-start {
    position: absolute;
    left: 25px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #64748b;
    font-family: 'Neue', sans-serif;
}

.label-end {
    position: absolute;
    right: 25px;
    transform: translateX(50%);
    font-size: 14px;
    color: #64748b;
    font-family: 'Neue', sans-serif;
}

.risk-text {
    text-align: center;
    line-height: 28px;
    font-family: 'Neue', sans-serif;
    font-weight: 500;
    transition: color 0.3s ease-in-out;
}

.progress-container {
    margin-top: 64px;
}

.btn-container {
    display: flex;
    gap: 16px;
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
}


.check-another-btn {
    margin: 0;
}
</style>
